import { computed, onUnmounted, ref } from 'vue';
import { useHighlightDisplay } from '@core/composables/use-highlight-display';
import { claimQatcHighlight, releaseQatcHighlight, QATC_HIGHLIGHT_FEATURE_NAME } from './qatc-highlight-singleton';

export function useQatcHighlight(eligible: boolean) {
  const { isStatusValid, setHighlightStatus } = useHighlightDisplay(QATC_HIGHLIGHT_FEATURE_NAME, {});
  const wasValidAtMount = isStatusValid.value;
  const isClaimed = eligible && wasValidAtMount ? claimQatcHighlight() : false;
  onUnmounted(() => { if (isClaimed) { releaseQatcHighlight(); } });

  const locallyVisible = ref(true);
  const dismissHighlight = () => {
    locallyVisible.value = false;
    setHighlightStatus(QATC_HIGHLIGHT_FEATURE_NAME);
  };
  const highlightVisible = computed(() => isClaimed && locallyVisible.value);

  return { highlightVisible, dismissHighlight };
}
